import {
  createExperience as publicCreateExperience,
  getExperience as publicGetExperience,
  getExperienceBySlug as publicGetExperienceBySlug,
  updateExperience as publicUpdateExperience,
  queryExperiences as publicQueryExperiences,
  typedQueryExperiences as publicTypedQueryExperiences,
  searchExperiences as publicSearchExperiences,
  bulkUpdateExperiences as publicBulkUpdateExperiences,
  bulkUpdateExperienceTags as publicBulkUpdateExperienceTags,
  bulkUpdateExperienceTagsByFilter as publicBulkUpdateExperienceTagsByFilter,
  bulkArchiveExperiences as publicBulkArchiveExperiences,
  bulkUnarchiveExperiences as publicBulkUnarchiveExperiences,
} from './table-reservations-v1-experience-experiences.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ExperienceQuery,
  ExperiencesQueryBuilder,
  typedQueryExperiences as universalTypedQueryExperiences,
} from './table-reservations-v1-experience-experiences.universal.js';
import { onExperienceCreated as publicOnExperienceCreated } from './table-reservations-v1-experience-experiences.public.js';
import { onExperienceTagsModified as publicOnExperienceTagsModified } from './table-reservations-v1-experience-experiences.public.js';
import { onExperienceUpdated as publicOnExperienceUpdated } from './table-reservations-v1-experience-experiences.public.js';

function customQueryExperiences(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryExperiences(httpClient)(),
    typedQueryFunction: (query: ExperienceQuery) =>
      publicTypedQueryExperiences(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ExperiencesQueryBuilder;
  function overloadedQuery(
    query: ExperienceQuery
  ): ReturnType<typeof universalTypedQueryExperiences>;
  function overloadedQuery(query?: ExperienceQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createExperience: MaybeContext<
  BuildRESTFunction<typeof publicCreateExperience> &
    typeof publicCreateExperience
> = /*#__PURE__*/ createRESTModule(publicCreateExperience);
export const getExperience: MaybeContext<
  BuildRESTFunction<typeof publicGetExperience> & typeof publicGetExperience
> = /*#__PURE__*/ createRESTModule(publicGetExperience);
export const getExperienceBySlug: MaybeContext<
  BuildRESTFunction<typeof publicGetExperienceBySlug> &
    typeof publicGetExperienceBySlug
> = /*#__PURE__*/ createRESTModule(publicGetExperienceBySlug);
export const updateExperience: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExperience> &
    typeof publicUpdateExperience
> = /*#__PURE__*/ createRESTModule(publicUpdateExperience);
export const searchExperiences: MaybeContext<
  BuildRESTFunction<typeof publicSearchExperiences> &
    typeof publicSearchExperiences
> = /*#__PURE__*/ createRESTModule(publicSearchExperiences);
export const bulkUpdateExperiences: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateExperiences> &
    typeof publicBulkUpdateExperiences
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateExperiences);
export const bulkUpdateExperienceTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateExperienceTags> &
    typeof publicBulkUpdateExperienceTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateExperienceTags);
export const bulkUpdateExperienceTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateExperienceTagsByFilter> &
    typeof publicBulkUpdateExperienceTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateExperienceTagsByFilter);
export const bulkArchiveExperiences: MaybeContext<
  BuildRESTFunction<typeof publicBulkArchiveExperiences> &
    typeof publicBulkArchiveExperiences
> = /*#__PURE__*/ createRESTModule(publicBulkArchiveExperiences);
export const bulkUnarchiveExperiences: MaybeContext<
  BuildRESTFunction<typeof publicBulkUnarchiveExperiences> &
    typeof publicBulkUnarchiveExperiences
> = /*#__PURE__*/ createRESTModule(publicBulkUnarchiveExperiences);
export const queryExperiences: MaybeContext<
  BuildRESTFunction<typeof customQueryExperiences> &
    typeof customQueryExperiences
> = /*#__PURE__*/ createRESTModule(customQueryExperiences);
/**
 * Triggered when an experience is created.
 */
export const onExperienceCreated: BuildEventDefinition<
  typeof publicOnExperienceCreated
> &
  typeof publicOnExperienceCreated = createEventModule(
  publicOnExperienceCreated
);
/**
 * Triggered when a tag on an experience is modified.
 */
export const onExperienceTagsModified: BuildEventDefinition<
  typeof publicOnExperienceTagsModified
> &
  typeof publicOnExperienceTagsModified = createEventModule(
  publicOnExperienceTagsModified
);
/**
 * Triggered when an experience is updated.
 */
export const onExperienceUpdated: BuildEventDefinition<
  typeof publicOnExperienceUpdated
> &
  typeof publicOnExperienceUpdated = createEventModule(
  publicOnExperienceUpdated
);

export {
  TableAvailabilityType,
  TableAssignmentType,
  TableManagementMode,
  Unit,
  Mode,
  StartDaysAndTimesDayOfWeek,
  Recurrence,
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Variant,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  Type,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  Origin,
  BannerPosition,
  LayoutDataBackgroundType,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  PaymentPolicyType,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  SearchDetailsMode,
  PlacementType,
  DayOfWeek,
  ResolutionMethod,
  WebhookIdentityType,
} from './table-reservations-v1-experience-experiences.universal.js';
export {
  Experience,
  Table,
  TableCombination,
  SpecificTablesOptions,
  OnOptions,
  OnOptionsOptionsOneOf,
  StartDaysAndTimes,
  WeeklyOptions,
  OneTimeOptions,
  Entry,
  EntryRecurrenceOptionsOneOf,
  PartySize,
  NoticePeriod,
  Approval,
  MaxGuests,
  OnlineReservationsBusinessSchedule,
  PrivacyPolicy,
  PrivacyPolicyValueOneOf,
  TermsAndConditions,
  TermsAndConditionsValueOneOf,
  CustomFieldDefinition,
  EmailMarketingCheckbox,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  PollSettings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  SketchData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackgroundImage,
  Banner,
  LayoutDataBackground,
  Backdrop,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  CheckboxListData,
  ListItemNodeData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  PerGuestOptions,
  DisplayInfo,
  PaymentPolicy,
  PaymentPolicyOptionsOneOf,
  OnlineReservations,
  ReservationForm,
  TableManagement,
  TableManagementOptionsOneOf,
  Configuration,
  ExtendedFields,
  Tags,
  TagList,
  SeoSettings,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  TagsModified,
  CreateExperienceRequest,
  CreateExperienceResponse,
  GetExperienceRequest,
  GetExperienceResponse,
  GetExperienceBySlugRequest,
  GetExperienceBySlugResponse,
  UpdateExperienceRequest,
  UpdateExperienceResponse,
  QueryExperiencesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryExperiencesResponse,
  CursorPagingMetadata,
  Cursors,
  SearchExperiencesRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  SearchDetails,
  SearchExperiencesResponse,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  BulkUpdateExperiencesRequest,
  MaskedExperience,
  BulkUpdateExperiencesResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateExperiencesResult,
  BulkActionMetadata,
  BulkUpdateExperienceTagsRequest,
  BulkUpdateExperienceTagsResponse,
  BulkUpdateExperienceTagsResult,
  BulkUpdateExperienceTagsByFilterRequest,
  BulkUpdateExperienceTagsByFilterResponse,
  BulkArchiveExperiencesRequest,
  BulkArchiveExperiencesResponse,
  BulkArchiveExperiencesResult,
  BulkUnarchiveExperiencesRequest,
  BulkUnarchiveExperiencesResponse,
  BulkUnarchiveExperiencesResult,
  SitePropertiesNotification,
  SitePropertiesEvent,
  Properties,
  Categories,
  Locale,
  Address,
  AddressHint,
  GeoCoordinates,
  BusinessSchedule,
  TimePeriod,
  SpecialHourPeriod,
  Multilingual,
  SupportedLanguage,
  ConsentPolicy,
  Translation,
  ChangeContext,
  ChangeContextPayloadOneOf,
  PropertiesChange,
  SiteCreated,
  SiteCloned,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ExperienceCreatedEnvelope,
  ExperienceTagsModifiedEnvelope,
  ExperienceUpdatedEnvelope,
  UpdateExperience,
  ExperiencesQueryResult,
  ExperiencesQueryBuilder,
  ExperienceQuerySpec,
  ExperienceSearchSpec,
  BulkUpdateExperiencesOptions,
  BulkUpdateExperienceTagsOptions,
  BulkUpdateExperienceTagsByFilterOptions,
} from './table-reservations-v1-experience-experiences.universal.js';
export { utils } from './table-reservations-v1-experience-experiences.universal.js';
export {
  TableAvailabilityTypeWithLiterals,
  TableAssignmentTypeWithLiterals,
  TableManagementModeWithLiterals,
  UnitWithLiterals,
  ModeWithLiterals,
  StartDaysAndTimesDayOfWeekWithLiterals,
  RecurrenceWithLiterals,
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  VariantWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  TypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  OriginWithLiterals,
  BannerPositionWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  PaymentPolicyTypeWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  SearchDetailsModeWithLiterals,
  PlacementTypeWithLiterals,
  DayOfWeekWithLiterals,
  ResolutionMethodWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpdateExperienceApplicationErrors,
  BulkUpdateExperiencesApplicationErrors,
  BulkUpdateExperienceTagsApplicationErrors,
  BulkUpdateExperienceTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  ExperienceQuery,
  CommonSearchWithEntityContext,
  ExperienceSearch,
} from './table-reservations-v1-experience-experiences.universal.js';
